// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import productStyle from 'assets/jss/material-kit-pro-react/views/landingPageSections/productStyle.jsx';
// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import InfoArea from 'components/InfoArea/InfoArea.jsx';
import React from 'react';
import TranslationService from '../../../services/translation/TransationService';

// @material-ui/icons

class SectionProduct extends React.Component {
  render() {
    const {classes} = this.props;
    return (
      <div className={classes.section} id="about-us">
        <GridContainer justify="center">
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title}>{ TranslationService.get('ABOUT_US.TITLE') }</h2>
            <h5 className={classes.description}>
              { TranslationService.get('ABOUT_US.CONTENT.P1') }
            </h5>
            <h5 className={classes.description}>
              { TranslationService.get('ABOUT_US.CONTENT.P2') }
            </h5>
          </GridItem>
        </GridContainer>
        <div>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <InfoArea
                title={ TranslationService.get('ABOUT_US.Q1.TITLE') }
                description={ TranslationService.get('ABOUT_US.Q1.CONTENT') }
                icon={() => <img
                  src={require('assets/img/Q1.png')}
                  style={{maxHeight: '61px'}}
                  alt="Not found"
                />}
                iconColor="info"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <InfoArea
                title={ TranslationService.get('ABOUT_US.Q2.TITLE') }
                description={ TranslationService.get('ABOUT_US.Q2.CONTENT') }
                icon={() =>
                  <img
                    src={require('assets/img/Q2.png')}
                    style={{maxHeight: '61px'}}
                    alt="Not found"
                  />
                }
                iconColor="success"
                vertical
              />
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(productStyle)(SectionProduct);



// WEBPACK FOOTER //
// ./src/views/QxQPublicPage/Sections/SectionProduct.jsx